import { createApp } from 'vue'
import App from './App.vue'
import VueRouter from './router'
import i18n from './i18n'
import axios from 'axios'
import VueNumber from 'vue-number-animation'
import VLazyImage from "v-lazy-image";
//VUELIDATE
import Vuelidate from 'vuelidate'
import 'animate.css';
import './assets/style/main.scss'
import AOS from "aos";
import "aos/dist/aos.css"
import VueAnimate from 'vue-animate-scroll'
import Toast from "vue-toastification";
import { maska } from 'maska';
import store from './store'
// import VueTheMask from 'vue-the-mask'
import ruRU from 'ant-design-vue/es/locale/ru_RU'
import moment from 'moment'
import 'moment/locale/ru'
import VueGtag from "vue-gtag";

import Maska from 'maska';


import '@/letsee/letsee'
import '@/letsee/letsee.css'

moment.locale('ru')

const token = localStorage.getItem('auth_token')

// Import the CSS or use your own!
import "vue-toastification/dist/index.css";
AOS.init();
const lang = localStorage.getItem('lang') || 'ru';
const isTest = window.location.hostname.includes("t1") || window.location.hostname.includes("localhost")
axios.defaults.baseURL = isTest ? "https://t1.cic.kz/api/" : 'https://cic.kz/api/';
axios.defaults.params = {
  'lang': lang,
};

if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

// Add axios interceptor to handle 401 responses
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      // Automatically logout user on 401 response
      store.dispatch('auth/logoutTokenUnactive')
      // Redirect to home page
      // window.location.href = '/' // who the fuck doing this shit. nurailym blyat ebychie vibe-coders
    }
    throw error
  }
)

const app = createApp(App)
app.use(i18n)
app.use(VueRouter)
app.use(VueNumber)
app.use(VueAnimate)
app.use(VLazyImage)
app.use(Maska)
app.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 1,
});
// app.use(Toast,options)
app.config.globalProperties.$LOCALE = ruRU

//Vuelidate
app.config.errorHandler = () => null;
app.config.warnHandler = () => null;
app.use(Vuelidate)
app.use(store)
app.use(moment)
// app.use(VueTheMask)
app.directive('mask', maska);
app.use(VueGtag, {
  config: { id: "G-DZ84BLE6XE" }
})
app.mount('#app')
